/** The memory frame: its globe, status line and details pocket. Memory content itself stays as written. */
export default {
  memory: "Memory",
  searchMemory: "Search memory",
  review: "Review",
  reviewWithCount: "Review {count}",
  reviewSuggestions: {
    one: "Review {count} suggestion",
    other: "Review {count} suggestions",
  },
  nothingToReview: "Nothing to review",
  fitGlobe: "Fit memory globe",
  upgrade: "Upgrade",
  openMemory: "Open memory",
  tileSearchEmpty: "No things match “{query}”.",

  focusPath: "Focus path",
  remembers: {
    one: "Denker remembers {count} thing.",
    other: "Denker remembers {count} things.",
  },
  remembersNothing: "Denker doesn’t remember anything yet.",
  needsReview: {
    one: "{count} needs your review",
    other: "{count} need your review",
  },
  learningStopped: {
    one: "Learning stopped: {count} capture failed.",
    other: "Learning stopped: {count} captures failed.",
  },
  retryLearning: "Retry",

  memoryDetails: "Memory details",
  sources: "Sources",
  history: "History",
  fact: "Fact",
  list: "List",
  showMore: "Show more",

  sourceDeleted: "Deleted source",
  sourceRedacted: "Redacted source",
  sourceTask: "Task {id}",
  sourceConversation: "Conversation message",
  sourceObserved: "Observed action",
  sourceVerification: "Verification receipt",
  sourceTaskOutcome: "Task outcome",
  sourcesEmpty: "No work evidence is linked to this yet.",
  noExcerpt: "No excerpt kept",
  sourceUnavailable: "Source unavailable",
  sourcesFailed: "Couldn’t load the sources. Try again.",

  historyRevision: "{operation} {actor}",
  operationLearned: "Learned",
  operationChanged: "Changed",
  operationConfirmed: "Confirmed",
  operationRejected: "Rejected",
  actorYou: "by you",
  actorDenker: "by Denker",
  actorCurated: "curated",
  historyGivenTo: "Given to {task}",
  untitledTask: "Untitled task",
  historyEmpty: "No activity yet.",

  searchThings: {
    one: "Search {count} thing",
    other: "Search {count} things",
  },
  suggestionsToReview: {
    one: "{count} suggestion to review",
    other: "{count} suggestions to review",
  },
  searchNothingCalled: "Nothing called “{query}” yet.",
  searchFailed: "Couldn’t search. Try again.",

  linkedTo: "Linked to {name}",
  searchKind: "Search {kind}",
  bundleNothingCalled: "Nothing called “{query}” here.",
  bundleAllOnGlobe: "Everything here is on the globe now.",
  bundleFailed: "Couldn’t load this list. Try again.",

  reviewDone: "Nothing left to review.",
  currently: "Currently",
  fromYourWords: "From your words",
  fromConversation: "From the conversation",
  accept: "Accept",
  reject: "Reject",
  suggestionPosition: "{index} of {total}",
  previousSuggestion: "Previous suggestion",
  nextSuggestion: "Next suggestion",
  saveChoiceFailed: "Couldn’t save your choice. Try again.",

  statusGoal: "Goal",
  statusDecision: "Decision",
  statusHypothesis: "Hypothesis",
  kindOfStatement: "Kind of statement",
  applies: "Applies",
  removeQualifier: "Remove {qualifier}",
  factExists: "Another fact already says this here.",
  saveFailed: "Couldn’t save. Try again.",

  factMissing: "Denker no longer remembers this.",
  removeFailed: "Couldn’t remove this memory. Try again.",
  removeTitle: "Remove this memory?",
  removeDescription:
    "This fact will leave active memory. Denker may learn it again from future work.",
  removing: "Removing…",
  forget: "Forget",
  forgetTitle: "Forget {name}?",
  forgetDescription:
    "Denker deletes {name} and every fact about it. This can’t be undone.",
  forgetting: "Forgetting…",

  loadFailed: "Couldn’t load this.",
  profile: "Profile",
  toReview: "To review",
  alsoLinked: "Also linked",
  learnedNothingAbout: "Denker hasn’t learned anything about {name} yet.",

  globeLoadFailed: "Couldn’t load memory.",
  thingsOnGlobe: "Things on the globe",
  you: "You",
  globeThing: "{name}, {kind}",
  globeThingMore: {
    one: ", {count} more link",
    other: ", {count} more links",
  },
  globeThingSuggested: ", suggested",
  globeThingInFocus: ", in focus",
} as const;
